module.exports = __webpack_public_path__ + "img/ticket_qr_locator.56048467.png";